/**
 * ATS Integration Docs Dialog Component
 */

import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { ScrollArea } from '../../ui/scroll-area';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';

const ATSDocsDialog = ({ open, onOpenChange, docs }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl max-h-[80vh]">
                <DialogHeader>
                    <DialogTitle>ATS Integration Guide</DialogTitle>
                    <DialogDescription>
                        Documentation for your ATS development team
                    </DialogDescription>
                </DialogHeader>
                <ScrollArea className="h-[60vh] mt-4">
                    {docs && (
                        <div className="space-y-6 pr-4">
                            <div>
                                <h3 className="font-semibold mb-2">Base URL</h3>
                                <code className="block p-2 rounded bg-muted text-sm">{docs.base_url}</code>
                            </div>
                            
                            <div>
                                <h3 className="font-semibold mb-2">Authentication Methods</h3>
                                <div className="space-y-3">
                                    <div className="p-3 rounded-lg border">
                                        <p className="font-medium">API Key</p>
                                        <p className="text-sm text-muted-foreground">{docs.authentication.api_key.description}</p>
                                        <code className="block mt-2 p-2 rounded bg-muted text-xs">{docs.authentication.api_key.example}</code>
                                    </div>
                                    <div className="p-3 rounded-lg border">
                                        <p className="font-medium">SSO Token</p>
                                        <p className="text-sm text-muted-foreground">{docs.authentication.sso.description}</p>
                                        <p className="text-xs mt-1">Token fields: {docs.authentication.sso.token_fields.join(', ')}</p>
                                    </div>
                                    <div className="p-3 rounded-lg border">
                                        <p className="font-medium">Magic Link</p>
                                        <p className="text-sm text-muted-foreground">{docs.authentication.magic_link.description}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <h3 className="font-semibold mb-2">API Endpoints</h3>
                                <div className="space-y-3">
                                    {Object.entries(docs.endpoints).map(([key, endpoint]) => (
                                        <div key={key} className="p-3 rounded-lg border">
                                            <div className="flex items-center gap-2 mb-2">
                                                <Badge variant="outline">{endpoint.method}</Badge>
                                                <code className="text-sm">{endpoint.url}</code>
                                            </div>
                                            <p className="text-sm text-muted-foreground">{endpoint.description}</p>
                                            {endpoint.body && (
                                                <pre className="mt-2 p-2 rounded bg-muted text-xs overflow-auto">
                                                    {JSON.stringify(endpoint.body, null, 2)}
                                                </pre>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            <div>
                                <h3 className="font-semibold mb-2">Python SSO Example</h3>
                                <pre className="p-3 rounded-lg bg-muted text-xs overflow-auto whitespace-pre-wrap">
                                    {docs.sso_token_example.python}
                                </pre>
                            </div>
                        </div>
                    )}
                </ScrollArea>
                <DialogFooter>
                    <Button onClick={() => onOpenChange(false)}>Close</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ATSDocsDialog;
